import { render, staticRenderFns } from "./HuaxianBanner.vue?vue&type=template&id=06ae5918&scoped=true&"
import script from "./HuaxianBanner.vue?vue&type=script&lang=js&"
export * from "./HuaxianBanner.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianBanner.vue?vue&type=style&index=0&id=06ae5918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae5918",
  null
  
)

export default component.exports